'use strict';

var React = require('react'),
    ClassNameMixin = require('../mixins/ClassNameMixin'),
    PureRenderMixin = require('../mixins/PureRenderMixin'),
    Footer = require('./Footer'),
    { PropTypes } = React;

require('./Page.less');

var Page = React.createClass({
  mixins: [ClassNameMixin, PureRenderMixin],

  propTypes: {
    background: PropTypes.string,
    showFooter: PropTypes.bool
  },

  getDefaultProps() {
    return {
      showFooter: false
    };
  },

  render() {
    return (
      <div className={this.getClassName()}
           style={this.getStyle()}>
        {this.props.children}

        {this.props.showFooter &&
          <Footer />
        }
      </div>
    );
  },

  getStyle() {
    if (this.props.background) {
      return {
        background: '#' + this.props.background
      };
    }
  }
});

module.exports = Page;



/** WEBPACK FOOTER **
 ** ./organisms/Page.jsx
 **/